
import { Spin } from 'antd';
import React from 'react';

import {
  AccessPointDetailsFragment,
  AccessPointType_enum,
} from '../../../graphql/hasura/generated';
import { AccessPointRoleManager } from '../../AccessPointRole/components/AccessPointRoleManager';
import { useAccessPointRolesQuery } from '../../AccessPointRole/hooks/useAccessPointRolesQuery';

import { AccessPointTypeEnumTag } from './AccessPointTypeEnumTag';

interface IAccessPointTypeDetailsProps {
  accessPoint: AccessPointDetailsFragment;
}

export const AccessPointTypeDetails: React.FC<IAccessPointTypeDetailsProps> = (props) => {
  const { accessPoint } = props;
  const { accessPointId, type } = accessPoint;

  const {
    accessPointRoles,
    roles,
    refetch,
    loading,
  } = useAccessPointRolesQuery({ accessPointId, type });

  const showAccessPointRoles = !loading && (
    !!accessPointRoles.length ||
    type === AccessPointType_enum.RESTRICTED_WHITELIST ||
    type === AccessPointType_enum.RESTRICTED_BLACKLIST
  );

  return (
    <>
      <div
        style={{
          display: 'inline-block',
          marginBottom: showAccessPointRoles ? 10 : 0,
        }}
      >
        <AccessPointTypeEnumTag type={type} />
      </div>
      <div style={{ float: 'right' }}>
        {loading && (
          <><Spin size='small' style={{ marginRight: 5 }} /> Loading...</>
        )}
        {showAccessPointRoles && (
          <AccessPointRoleManager
            accessPoint={accessPoint}
            accessPointRoles={accessPointRoles}
            roles={roles}
            refetch={refetch}
            readOnly
          />
        )}
      </div>
    </>
  );
};
